/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:4f27b4fd-81fc-42d7-8cb2-2b7a2f5ed0f1",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_aP1Mr0iFe",
    "aws_user_pools_web_client_id": "70hf642dsc2krs6vt1bkmrj3v",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_appsync_graphqlEndpoint": "https://gtnsna3i2bdsvonzi5m4fkfho4.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_user_files_s3_bucket": "mobiusgallerystorage102106-dev",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
